import type { CalculationResult, CalculatorInput, FeeProfile, MarketplaceCode } from '../engine/types';

export interface AppState {
  market: MarketplaceCode;
  profile: FeeProfile;
  input: CalculatorInput;
  result: CalculationResult | null;
}

export type StateListener = (state: AppState) => void;

export class Store {
  private state: AppState;
  private listeners: StateListener[] = [];

  constructor(initial: AppState) {
    this.state = initial;
  }

  getState(): AppState {
    return this.state;
  }

  setState(next: AppState): void {
    this.state = next;
    for (const listener of this.listeners) {
      listener(this.state);
    }
  }

  subscribe(listener: StateListener): () => void {
    this.listeners.push(listener);
    return () => {
      this.listeners = this.listeners.filter((candidate) => candidate !== listener);
    };
  }
}
